// ============================================================================
// MarketBadge — small chip used on market headers (e.g. cashout, boost)
// ============================================================================
// Caller is responsible for localising the label string. Tone controls the
// colour scheme — cashout = brand-yellow CTA, boost = secondary accent.
// ============================================================================

import type { ReactElement } from 'react';
import styles from './MarketBadge.module.css';

export interface MarketBadgeProps {
  label: string;
  tone: 'cashout' | 'boost';
}

const COIN_ICON = (
  <svg className="market-badge-icon" viewBox="0 0 16 16" aria-hidden="true">
    <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M8 4.5v7M5.5 6.5h3.25a1.5 1.5 0 010 3H5.5M5.5 9.5h3.25a1.5 1.5 0 010 3H5.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

export function MarketBadge({ label, tone }: MarketBadgeProps): ReactElement {
  const toneClass = tone === 'cashout' ? styles.cashout : styles.boost;
  return (
    <span className={`${styles.badge} ${toneClass}`}>
      {tone === 'cashout' && <span className={styles.icon}>{COIN_ICON}</span>}
      {label}
    </span>
  );
}

export default MarketBadge;
